import React, { useState, useEffect } from "react";
import { TextField, Grid, Select, MenuItem } from "@mui/material";
import { useUserData } from "components/customHooks/userDataContext";
import { useLocation, useNavigate } from "react-router-dom";
import { BackButton, dayNightTimeArray } from "components/helpers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import AddWorkDetails from "components/modals/AddWorkDetails";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

//API
import {
  getUserOrgDetails,
  getTimesheetDetails,
  getOrgProjectTasks,
  updateTimesheetStatus,
  submitTimesheet,
} from "apiHandler/actions";

//Icons
import IconButton from "@mui/material/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import DescriptionIcon from "@mui/icons-material/Description";

const UpdateUserTimeSheet = () => {
  const location = useLocation();

  const getFormattedDate = (date) => {
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return month + "/" + day + "/" + year;
  };

  const navigate = useNavigate();
  const userData = useUserData();
  const [dataArray, setDataArray] = useState([]);
  const [userOrgData, setUserOrgData] = useState({});

  const [weekStartDateA, setStartDateA] = useState(null);
  const [weekEndDateA, setEndDateA] = useState(null);

  const [weekStartingDate, setWeekStartingDate] = useState(null);
  const [weekEndingDate, setWeekEndingDate] = useState(null);
  const [timesheet_status, setTimesheet_status] = useState("");

  const [showAddModal, setShowAddModal] = useState(false);
  const [reverseData, setReverseData] = useState(null);
  const [workID, setWorkID] = useState("");

  const [comment, setComment] = useState("");
  const [employeeSignature, setEmployeeSignature] = useState("");
  const [esDate, setEsDate] = useState(new Date());

  const handleTimesheetdate = (data) => {
    const fDay1 = getFormattedDate(new Date(data));
    const fDay2 = fDay1.toString();
    return fDay2;
  };

  useEffect(() => {
    const fetchData = async () => {
      const timeSheetPayload = {
        user_id: userData?.email,
        timesheet_id: location.state.timesheet_id.toString(),
      };
      const timeSheetResponse = await getTimesheetDetails(timeSheetPayload);

      const filterTableData = timeSheetResponse.timesheet_dates_list.map(
        (el, index) => {
          return {
            id: el.id,
            obj_id: el.id,
            day: el.timesheet_date.slice(0, 3),
            obj_added: false,
            timesheet_date:
              el.timesheet_date !== null
                ? handleTimesheetdate(el.timesheet_date)
                : "",
            client_name: el.client_name ? el.client_name : "",
            project_name: el.project_name ? el.project_name : "",
            task_name: el.task_name ? el.task_name : "",
            project_ary: [el.project_name],
            task_ary: [el.task_name],
            notes: el.notes,
            check_in_time: el.check_in_time,
            check_out_time: el.check_out_time,
            check_in_check_out_time: 0,
            break_hrs: Number(el.break_hrs),
            total_hrs: Number(el.total_hrs),
            non_billable_hrs: Number(el.non_billable_hrs),
            work_hrs: Number(el.work_hrs),
            timesheet_id: el.timesheet_id,
            ary_index: index,
          };
        }
      );
      setDataArray(filterTableData);
      setStartDateA(
        getFormattedDate(new Date(timeSheetResponse.week_start_date))
      );
      setEndDateA(getFormattedDate(new Date(timeSheetResponse.week_end_date)));
      setWeekStartingDate(
        timeSheetResponse.week_start_date.slice(0, 16).replace(",", "")
      );
      setWeekEndingDate(
        timeSheetResponse.week_end_date.slice(0, 16).replace(",", "")
      );
      setTimesheet_status(timeSheetResponse.status);
      setComment(timeSheetResponse.notes);
      setEmployeeSignature(
        timeSheetResponse.user_signature === null
          ? ""
          : timeSheetResponse.user_signature
      );
      setEsDate(
        timeSheetResponse.user_signature_date === null
          ? ""
          : new Date(timeSheetResponse.user_signature_date)
      );
    };
    fetchData();
  }, []);

  const [supervisorName, setSupervisorName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [projectTask, setProjectTask] = useState([
    { project_name: "Select", task_name: "Select" },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        user_id: userData?.email,
      };
      const response = await getUserOrgDetails(payload);
      const data = response[0];
      setUserOrgData(response[0]);
      setOrganizationName(data.org_name);
      setSupervisorName(
        data.supervisor_first_name + " " + data.supervisor_last_name
      );
      const projectTasks = await getOrgProjectTasks(payload);
      setProjectTask(projectTasks);
    };
    fetchData();
  }, []);

  const [employeeID, setEmployeeID] = useState(userData?.email);
  const [employeeName, setEmployeeName] = useState(
    userData?.first_name + " " + userData?.last_name
  );

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };

  const getTimeSpan = (prop) => {
    let value = prop.split("-");
    let [from, to] = value;
    from = Number(from) / 100;
    to = Number(to) / 100;
    let from_abs = Math.floor(from) * 60 + (from % 1).toFixed(2) * 100;
    let to_abs = Math.floor(to) * 60 + (to % 1).toFixed(2) * 100;
    let diff = to_abs - from_abs;
    let minutes = diff % 60;
    let hrs = (diff - minutes) / 60;
    return { hrs, minutes };
  };

  const handleRowAdd = (data) => {
    let objData = { ...data, obj_added: true };
    const temp = [...dataArray];
    temp.splice(data.ary_index, 0, objData);

    const a = temp.map((el, index) => {
      return {
        id: index,
        obj_id: el.id,
        obj_added: el.obj_added,
        day: el.day,
        timesheet_date: el.timesheet_date,
        client_name: el.client_name,
        project_name: el.project_name,
        task_name: el.task_name,
        project_ary: el.project_ary,
        task_ary: el.task_ary,
        notes: el.notes,
        check_in_time: el.check_in_time,
        check_out_time: el.check_out_time,
        check_in_check_out_time: el.check_in_check_out_time,
        break_hrs: el.break_hrs,
        total_hrs: el.total_hrs,
        non_billable_hrs: el.non_billable_hrs,
        work_hrs: el.work_hrs,
        timesheet_id: el.timesheet_id,
      };
    });
    setDataArray(a);
  };

  const handleRowRomove = (data) => {
    let temp = [...dataArray];
    const filterData = temp.filter((row) => {
      return row.id !== data.id || row.obj_added !== data.obj_added;
    });
    setDataArray(filterData);
  };

  const getData = (data) => {
    let modified = dataArray.map((row) => {
      if (row?.id === workID) row.notes = data;
      return row;
    });
    setDataArray(modified);
  };

  const getIdData = (id) => {
    setWorkID(id);
  };

  const handleWorkTextChange = async (data) => {
    setShowAddModal(true);
    getIdData(data?.id);
    setReverseData(data.notes);
  };

  const clients = projectTask.map((el) => {
    return el.client_name;
  });

  const handleClientDrpdownChange = async (e, event) => {
    const ary = projectTask.filter((el) => {
      return el.client_name === event.target.value;
    });

    const projects = ary.map((el) => {
      return el.project_name;
    });
    const filterProjects = removeDuplicates(projects);

    const tasks = ary.map((el) => {
      return el.task_name;
    });
    const filterTasks = removeDuplicates(tasks);

    let modified = dataArray.map((row) => {
      if (row.id === e.row.id) {
        row.client_name = event.target.value;
        row.project_ary = filterProjects;
        row.task_ary = filterTasks;
      }
      return row;
    });
    setDataArray(modified);
  };

  const filterClients = removeDuplicates(clients);

  const clientDropdown = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.client_name}
        onChange={(event) => handleClientDrpdownChange(e, event)}
        disabled={
          timesheet_status === "Submitted" || timesheet_status === "Approved"
            ? true
            : false
        }
      >
        {filterClients.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleProjectDrpdownChange = async (e, event) => {
    let modified = dataArray.map((row) => {
      if (row.id === e.row.id) {
        row.project_name = event.target.value;
        row.project_ary[0] = event.target.value;
      }
      return row;
    });
    setDataArray(modified);
  };

  const projectDropdown = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.project_name}
        onChange={(event) => handleProjectDrpdownChange(e, event)}
        disabled={
          timesheet_status === "Submitted" || timesheet_status === "Approved"
            ? true
            : false
        }
      >
        {e.row.project_ary.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleTaskDrpdownChange = async (e, event) => {
    let modified = dataArray.map((row) => {
      if (row.id === e.row.id) {
        row.task_name = event.target.value;
        row.task_ary[0] = event.target.value;
      }
      return row;
    });
    setDataArray(modified);
  };

  const taskDropdown = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.task_name}
        onChange={(event) => handleTaskDrpdownChange(e, event)}
        disabled={
          timesheet_status === "Submitted" || timesheet_status === "Approved"
            ? true
            : false
        }
      >
        {e.row.task_ary.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleFromTimeChange = (id, event) => {
    let modified = dataArray.map((row) => {
      if (row.id === id) {
        row.check_in_time = event.target.value;
      }
      return row;
    });
    setDataArray(modified);
  };

  const checkInTimeHandler = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.check_in_time}
        onChange={(event) => handleFromTimeChange(e.row.id, event)}
        disabled={
          timesheet_status === "Submitted" || timesheet_status === "Approved"
            ? true
            : false
        }
      >
        {dayNightTimeArray.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleToTimeChange = (id, event) => {
    let x = event.target.value.slice("0", "2");
    let y = Number(x);

    let modified = dataArray.map((row) => {
      if (row.id === id) {
        let cx = row.check_in_time.slice("0", "2");
        let cy = Number(cx);

        if (y > cy) {
          let a = row.check_in_time + "-" + event.target.value;
          let c = a.replaceAll(":", "");
          let b = getTimeSpan(c);
          console.log("b---", b);
          let ax = b.minutes;
          let yy = 0;
          if (ax === 30) {
            yy = 50;
          } else {
            yy = ax;
          }
          console.log("yy---", yy);
          const filterHoursData = b.hrs.toString() + "." + yy.toString();
          const roundCheckData = Number(filterHoursData);
          console.log("roundCheckData", roundCheckData);
          row.check_out_time = event.target.value;
          row.check_in_check_out_time = roundCheckData;
          row.total_hrs = roundCheckData;
          row.work_hrs = roundCheckData;
        } else {
          alert("Check-out Time should be greater than Check-in time.");
        }
      }
      return row;
    });
    setDataArray(modified);
  };

  const checkOutTimeHandler = (e) => {
    return (
      <Select
        labelId="Input label"
        id="Select"
        value={e.row.check_out_time}
        onChange={(event) =>
          e.row.check_in_time === "00:00"
            ? alert("Please select Check-In time first")
            : handleToTimeChange(e.row.id, event)
        }
        disabled={
          timesheet_status === "Submitted" || timesheet_status === "Approved"
            ? true
            : false
        }
      >
        {dayNightTimeArray.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    );
  };

  const handleBreakHours = async (e, event) => {
    let modified = dataArray.map((row) => {
      if (row?.id === e.row?.id) {
        row.break_hrs = event.target.value;
        row.total_hrs = (
          row.check_in_check_out_time - event.target.value
        ).toFixed(2);
        row.work_hrs = (
          row.check_in_check_out_time - event.target.value
        ).toFixed(2);
      }
      return row;
    });
    setDataArray(modified);
  };

  const breakHoursInput = (e) => {
    return (
      <input
        style={{ width: 60, textAlign: "center" }}
        type="number"
        min="1"
        value={e.row.break_hrs}
        onChange={(event) => handleBreakHours(e, event)}
        disabled={e.row.check_in_check_out_time === 0 ? true : false}
      />
    );
  };

  const handleNonBillableHours = async (e, event) => {
    let modified = dataArray.map((row) => {
      if (row?.id === e.row?.id) {
        row.non_billable_hrs = event.target.value;
        row.work_hrs = (row.total_hrs - event.target.value).toFixed(2);
      }
      return row;
    });
    setDataArray(modified);
  };

  const nonBillableHoursInput = (e) => {
    return (
      <input
        style={{ width: 60, textAlign: "center" }}
        type="number"
        min="1"
        value={e.row.non_billable_hrs}
        onChange={(event) => handleNonBillableHours(e, event)}
        disabled={e.row.check_in_check_out_time === 0 ? true : false}
      />
    );
  };

  const break_hours_Data = () => {
    const data = dataArray.reduce((a, b) => +a + +b.break_hrs, 0);
    return Number(data).toFixed(2);
  };
  const breakHours_1 = break_hours_Data();

  const total_hours_Data = () => {
    const data = dataArray.reduce((a, b) => +a + +b.total_hrs, 0);
    return Number(data).toFixed(2);
  };
  const total_hours_1 = total_hours_Data();

  const non_billable_hoursData = () => {
    const data = dataArray.reduce((a, b) => +a + +b.non_billable_hrs, 0);
    return Number(data).toFixed(2);
  };
  const non_billable_hours_1 = non_billable_hoursData();

  const total_work_hoursData = () => {
    const data = dataArray.reduce((a, b) => +a + +b.work_hrs, 0);
    return Number(data).toFixed(2);
  };
  const total_work_hours_1 = total_work_hoursData();

  const DataGridCustomFooterComponent = () => {
    return (
      <div>
        <span style={{ marginRight: "30px", fontWeight: "semibold" }}>
          {dataArray.length
            ? `Total Break Hours: ${breakHours_1}`
            : `Total Break Hours: 0`}
        </span>
        <span style={{ marginRight: "30px", fontWeight: "semibold" }}>
          {dataArray.length
            ? `Total Hours: ${total_hours_1}`
            : `Total Hours: 0`}
        </span>
        <span style={{ marginRight: "30px", fontWeight: "semibold" }}>
          {dataArray.length
            ? `Total Non-Billable Hours: ${non_billable_hours_1}`
            : `Total Non-Billable Hours: 0`}
        </span>
        <span style={{ marginRight: "80px", fontWeight: "semibold" }}>
          {dataArray.length
            ? `Total Work Hours: ${total_work_hours_1}`
            : `Total Work Hours: 0`}
        </span>
      </div>
    );
  };

  const columns = [
    {
      field: "",
      headerName: "Action",
      minWidth: 100,
      align: "center",
      flex: 1,
      renderCell: (e) => (
        <>
          <IconButton onClick={() => handleRowAdd(e.row)} color="secondary">
            <AddIcon fontSize="small" />
          </IconButton>
          <IconButton onClick={() => handleRowRomove(e.row)} color="secondary">
            <RemoveIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => handleWorkTextChange(e.row)}
            color="secondary"
          >
            <DescriptionIcon fontSize="small" />
          </IconButton>
        </>
      ),
    },
    {
      field: "timesheet_date",
      headerName: "Day",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "client_name",
      headerName: "Client",
      flex: 1,
      minWidth: 150,
      renderCell: clientDropdown,
    },
    {
      field: "project_name",
      headerName: "Client/Project",
      flex: 1,
      minWidth: 150,
      renderCell: projectDropdown,
    },
    {
      field: "task_name",
      headerName: "Task",
      flex: 1,
      minWidth: 140,
      renderCell: taskDropdown,
    },
    {
      field: "check_in_time",
      headerName: "Check-In",
      flex: 1,
      minWidth: 110,
      renderCell: checkInTimeHandler,
    },
    {
      field: "check_out_time",
      headerName: "Check-Out",
      flex: 1,
      minWidth: 120,
      renderCell: checkOutTimeHandler,
    },
    {
      field: "break_hrs",
      headerName: "Break Hours",
      align: "center",
      flex: 1,
      minWidth: 131,
      renderCell: breakHoursInput,
    },
    {
      field: "non_billable_hrs",
      headerName: "Non Billable Hours",
      align: "center",
      flex: 1,
      minWidth: 172,
      renderCell: nonBillableHoursInput,
    },
  ];

  const handleTimesheetRecall = async (status_data) => {
    const payload = {
      user_id: userData?.email,
      timesheet_id: location.state.timesheet_id.toString(),
      status: status_data,
    };
    const response = await updateTimesheetStatus(payload);
    console.log(response);
    navigate("/timesheet");
  };

  const handleTimesheetFormSubmit = async (status_data) => {
    let arrayCopy = JSON.parse(JSON.stringify(dataArray));

    const a = arrayCopy.filter((el) => {
      return el.obj_added === false;
    });

    const b = arrayCopy.filter((el) => {
      return el.obj_added === true;
    });

    const y = b.map((el) => ({
      day: el.day,
      obj_added: el.obj_added,
      timesheet_date: el.timesheet_date,
      client_name: el.client_name,
      project_name: el.project_name,
      task_name: el.task_name,
      project_ary: el.project_ary,
      task_ary: el.task_ary,
      notes: el.notes,
      check_in_time: el.check_in_time,
      check_out_time: el.check_out_time,
      check_in_check_out_time: el.check_in_check_out_time,
      break_hrs: el.break_hrs,
      total_hrs: el.total_hrs,
      non_billable_hrs: el.non_billable_hrs,
      work_hrs: el.work_hrs,
      timesheet_id: el.timesheet_id,
    }));

    const x = a.map((el) => ({
      ...el,
      id: el.obj_id,
    }));

    const c = x.concat(y);

    const payload = {
      timesheet_id: location.state.timesheet_id,
      user_id: userOrgData.user_id,
      org_id: userOrgData.org_id,
      week_start_date: weekStartDateA.toString(),
      week_end_date: weekEndDateA.toString(),
      total_break_hrs: breakHours_1,
      total_non_billable_hrs: non_billable_hours_1,
      total_work_hrs: total_work_hours_1,
      total_hrs: total_hours_1,
      status: status_data,
      user_signature:
        userOrgData.user_first_name + " " + userOrgData.user_last_name,
      notes: comment,
      timesheet_dates_list: c,
    };
    const response = await submitTimesheet(payload);
    navigate("/timesheet");
    console.log("response", response);
  };

  return (
    <div className="check-patient-modal" style={{ margin: "auto" }}>
      <Grid container spacing={2}>
        <Grid container item spacing={1}>
          <Grid item xs={10} sm={10} md={10}>
            <BackButton onClick={() => navigate(-1)} />
          </Grid>
          <Grid item xs={2} sm={2} md={2}>
            <button
              style={{
                float: "right",
                border: "none",
                color: "#d91a5f",
                padding: "3px",
              }}
              onClick={() => navigate("/login")}
            >
              <h4>Log Out</h4>
            </button>
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
            <p
              style={{
                color: "#cb3366",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >{`Week of ${weekStartingDate}  To  ${weekEndingDate}`}</p>
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Employee ID</span>
            <TextField
              disabled={
                timesheet_status === "Submitted" ||
                timesheet_status === "Approved"
                  ? true
                  : false
              }
              variant="standard"
              type="text"
              className="full-width"
              value={employeeID}
              onChange={(e) => setEmployeeID(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Employee Name</span>
            <TextField
              disabled={
                timesheet_status === "Submitted" ||
                timesheet_status === "Approved"
                  ? true
                  : false
              }
              variant="standard"
              type="text"
              className="full-width"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Supervisor Name</span>
            <TextField
              disabled={
                timesheet_status === "Submitted" ||
                timesheet_status === "Approved"
                  ? true
                  : false
              }
              variant="standard"
              type="text"
              className="full-width"
              value={supervisorName}
              onChange={(e) => setSupervisorName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Organization</span>
            <TextField
              disabled={
                timesheet_status === "Submitted" ||
                timesheet_status === "Approved"
                  ? true
                  : false
              }
              variant="standard"
              type="text"
              className="full-width"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>TimeSheet Status</span>
            <TextField
              disabled
              variant="standard"
              type="text"
              className="full-width"
              value={timesheet_status}
              onChange={(e) => setTimesheet_status(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container item>
          <Grid item xs={12} sm={12} md={12}>
            <Box
              sx={{
                "& .sun": {
                  backgroundColor: "#f5fffa",
                  color: "#1a3e72",
                },
                "& .mon": {
                  backgroundColor: "#b9d5ff91",
                  color: "#1a3e72",
                },
                "& .tue": {
                  backgroundColor: "#fafad2",
                  color: "#1a3e72",
                },
                "& .wed": {
                  backgroundColor: "#E6E6FA",
                  color: "#1a3e72",
                },
                "& .thu": {
                  backgroundColor: "#F0FFFF ",
                  color: "#1a3e72",
                },
                "& .fri": {
                  backgroundColor: "#FFE4E1",
                  color: "#1a3e72",
                },
              }}
            >
              <DataGrid
                rows={dataArray}
                columns={columns}
                autoHeight
                disableRowSelectionOnClick
                pagination
                pageSize={50}
                density="compact"
                components={{
                  Pagination: DataGridCustomFooterComponent,
                }}
                getCellClassName={(params) => {
                  if (params.row.day === "Sun") {
                    return "sun";
                  } else if (params.row.day === "Mon") {
                    return "mon";
                  } else if (params.row.day === "Tue") {
                    return "tue";
                  } else if (params.row.day === "Wed") {
                    return "wed";
                  } else if (params.row.day === "Thu") {
                    return "thu";
                  } else if (params.row.day === "Fri") {
                    return "fri";
                  }
                }}
              />
            </Box>
          </Grid>
          <Grid container item spacing={1}>
            <Grid item xs={6} sm={6} md={12}>
              <span style={{ color: "#cb3366" }}>Comment</span>
              <TextField
                disabled={
                  timesheet_status === "Submitted" ||
                  timesheet_status === "Approved"
                    ? true
                    : false
                }
                variant="standard"
                type="text"
                className="full-width"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <span style={{ color: "#cb3366" }}>Employee Signature</span>
              <TextField
                disabled={
                  timesheet_status === "Submitted" ||
                  timesheet_status === "Approved"
                    ? true
                    : false
                }
                variant="standard"
                type="text"
                className="full-width"
                value={employeeSignature}
                onChange={(e) => setEmployeeSignature(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <span style={{ color: "#cb3366" }}>
                {esDate === "" ? "No Date Selected" : "Date"}
              </span>
              <KeyboardDatePicker
                disabled={
                  timesheet_status === "Submitted" ||
                  timesheet_status === "Approved"
                    ? true
                    : false
                }
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                value={esDate}
                onChange={(e) => setEsDate(e)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}></Grid>
            <Grid item xs={6} sm={6} md={4}></Grid>
          </Grid>
        </Grid>
      </Grid>
      {timesheet_status === "Submitted" || timesheet_status === "Approved" ? (
        <div className="udm-btn-cont">
          <Button
            size="small"
            variant="contained"
            color="success"
            style={{
              marginTop: "10px",
            }}
            onClick={() => handleTimesheetRecall("Draft")}
          >
            Recall
          </Button>
        </div>
      ) : (
        <div className="udm-btn-cont">
          <Button
            size="small"
            variant="outlined"
            color="error"
            style={{
              marginTop: "10px",
            }}
            onClick={() =>
              1 > total_work_hours_1
                ? alert("please select check-in/checkout time first")
                : handleTimesheetFormSubmit("Submitted")
            }
          >
            Submit
          </Button>
          <Button
            variant="contained"
            size="small"
            style={{
              color: "white",
              backgroundColor: "#cb3366",
              marginTop: "10px",
              marginLeft: "10px",
            }}
            onClick={() =>
              1 > total_work_hours_1
                ? alert("please select check-in/checkout time first")
                : handleTimesheetFormSubmit("Draft")
            }
          >
            Save
          </Button>
        </div>
      )}
      {showAddModal ? (
        <AddWorkDetails
          reverseData={reverseData}
          getData={getData}
          onClose={() => setShowAddModal(false)}
        />
      ) : null}
    </div>
  );
};

export default UpdateUserTimeSheet;
